import classNames from "components/ui/classNames";
import Link from "next/link";
import { FormattedMessage } from "react-intl";

interface IFooterProps {
  className?: string;
}
export default function Footer({ className }: IFooterProps) {
  return (
    <footer
      className={classNames(
        "flex flex-col items-center gap-2 text-center text-sm font-normal text-gray-500",
        className,
      )}
    >
      <div>
        <p>© {new Date().getFullYear()} Fundamentei</p>
      </div>
      <div className="flex items-center gap-x-2">
        <Link href="/terms" className="hover:underline">
          <FormattedMessage defaultMessage="Termos de Uso" id="6FD7WZ" />
        </Link>
        <span>&bull;</span>
        <Link href="/privacy" className="hover:underline">
          <FormattedMessage defaultMessage="Privacidade" id="LN4JSv" />
        </Link>
      </div>
    </footer>
  );
}
